export { default as ProductCardsContainer } from "./ProductCardsContainer";
export { default as ProductCard } from "./ProductCard";



// WEBPACK FOOTER //
// ./src/components/ProductCards/index.js